<template>
<div>
  <form class="rate-form" @submit.prevent="submitRating">
    <div>
      <label class="survey-question">How likely are you to recommend
        <span class="name">
          {{inspectorName}}
        </span>
        for an inspection?
      </label>

      <v-flex offset-md3 md6 xs12>
        <v-rating
          hover="hover"
          :dense="$vuetify.breakpoint.smAndDown"
          length="10"
          v-model="rating.rating"
          class="ratings-slider"
          color="blue"
          id="rating"
          min="1"
          ticks="always"/>
      </v-flex>
      <v-flex offset-sm3 sm6 xs12>
        <div class="scale">
          <label class="not-likely">Not likely</label>
          <label class="absolutely">Absolutely</label>
        </div>
      </v-flex>
    </div>

    <div class="comment-box">
      <label for="comment">Comments or suggestions</label>
      <textarea
        v-model="rating.comment"
        class="comment"
        cols="30"
        id="comment"
        rows="10" />
    </div>

    <div class="public">
      <input
        v-model="rating.publish"
        class="public-check"
        id="make_public"
        type="checkbox"
        value="value" />
      <label for="make_public" class="public-label">make comment public</label>
    </div>

    <button class="btn-primary btn-submit" type="submit">Submit Survey</button>
  </form>
</div>
</template>

<script>
import { mapState } from 'vuex';
import sanitizeHTML from 'sanitize-html';

export default {
  data() {
    return {
      rating: {
        rating: 10,
        publish: true,
        comment: '',
      },
    };
  },
  props: {
    inspectorId: {
      type: Number,
      required: true,
    },
    inspectorName: {
      type: String,
      required: true,
    },
  },
  computed: {
    ...mapState('User', {
      currentUser: state => state.currentUser,
    }),
  },
  methods: {
    submitRating() {
      this.rating.customerId = this.currentUser.legacyId;
      this.rating.inspectorId = this.inspectorId;
      this.rating.comment = sanitizeHTML(this.rating.comment, {
        allowedTags: [],
        allowedAttributes: {},
      });
      this.$emit('submitRating', this.rating);
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../../styles/vars/theme';
@import '../../styles/vars/typography';

.comment {
  margin-bottom: 40px;
  width: 100%;
}

.name {
  font-weight: $typography-weight-bold;
}

.survey-question {
  margin-bottom: 80px;
}

.public {
  margin-bottom: 30px;

  &-check,
  &-label {
    display: inline-block;
    margin: 0;
    padding: 0;
  }

  &-label {
    padding-left: 10px;
  }
}

.btn-submit {
  display: block;
  margin: 0 auto;
}

.v-alert {
  padding-bottom: 60px;
}

.comment-box {
  clear: both;
}

.ratings-slider,
.scale {
  text-align: center;
}

.scale {
  margin-bottom: 40px;

  .not-likely {
    float: left;
  }

  .absolutely {
    float: right;
  }
}
</style>
